import { render, staticRenderFns } from "./MarketingApprovalModal.vue?vue&type=template&id=43ee60b7&"
import script from "./MarketingApprovalModal.vue?vue&type=script&lang=js&"
export * from "./MarketingApprovalModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketingApprovalModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports